import { useState } from 'react';
import { DoorOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import ExitRitualOverlay, { clearSession } from './ExitRitualOverlay';

interface ExitButtonProps {
  className?: string;
  variant?: 'icon' | 'text' | 'full';
}

const ExitButton = ({ className = '', variant = 'full' }: ExitButtonProps) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleConfirmExit = () => {
    clearSession();
    setShowOverlay(false);
    navigate('/');
  };

  if (variant === 'icon') {
    return (
      <>
        <button
          onClick={() => setShowOverlay(true)}
          className={`p-2 text-muted-foreground/40 hover:text-muted-foreground/70 transition-colors ${className}`}
          title={t('close_the_door') || 'Close the Door'}
        >
          <DoorOpen className="w-5 h-5" />
        </button>
        <ExitRitualOverlay
          isOpen={showOverlay}
          onClose={() => setShowOverlay(false)}
          onConfirmExit={handleConfirmExit}
        />
      </>
    );
  }

  if (variant === 'text') {
    return (
      <>
        <button
          onClick={() => setShowOverlay(true)}
          className={`text-xs text-muted-foreground/30 hover:text-muted-foreground/50 transition-colors ${className}`}
        >
          {t('close_the_door') || 'Close the Door'}
        </button>
        <ExitRitualOverlay
          isOpen={showOverlay}
          onClose={() => setShowOverlay(false)}
          onConfirmExit={handleConfirmExit}
        />
      </>
    );
  }

  return (
    <>
      <button
        onClick={() => setShowOverlay(true)}
        className={`flex items-center gap-2 px-4 py-2 border border-border/20 hover:border-border/40 bg-card/30 hover:bg-card/50 rounded-lg text-sm text-muted-foreground/60 hover:text-muted-foreground transition-all ${className}`}
      >
        <DoorOpen className="w-4 h-4" />
        <span>{t('close_the_door') || 'Close the Door'}</span>
      </button>
      <ExitRitualOverlay
        isOpen={showOverlay}
        onClose={() => setShowOverlay(false)}
        onConfirmExit={handleConfirmExit}
      />
    </>
  );
};

export default ExitButton;
